<template>
  <details-layout @close-drawer="$emit('close-drawer')">
    <template
      v-if="detailsDescription.header"
      #header
    >
      {{ detailsDescription.header }}
    </template>
    <template
      v-if="detailsDescription.subHeader"
      #sub-header
    >
      {{ detailsDescription.subHeader }}
    </template>
    <template
      v-if="detailsDescription.content"
      #content
    >
      <v-expansion-panels
        :key="detailsListId"
        flat
        multiple
        class="mt-8"
      >
        <v-expansion-panel
          v-for="(item, index) in detailsContent"
          :key="snakeCase(item.name)"
          :class="{ 'mb-4': !isLastElemInArray(index, detailsDescription.content) }"
        >
          <v-expansion-panel-header>
            <h2 class="text-capitalize">{{ item.name }}</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <p
              v-for="(paragraph, parIndex) in item.description"
              :key="`par-${parIndex}`"
              :class="{ 'mb-4': !isLastElemInArray(parIndex, item.description) }"
            >
              {{ paragraph }}
            </p>
          </v-expansion-panel-content>
          <v-divider />
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </details-layout>
</template>

<script>
import DetailsLayout from '@/components/car/Results/detailsDrawer/DetailsLayout.vue';
import { snakeCase } from 'lodash';

export default {
  name: 'details-description',
  components: { DetailsLayout },
  props: {
    detailsDescription: {
      type: Object,
      required: true,
    },
  },
  computed: {
    detailsContent () {
      if (this.detailsDescription.contentLimiter) {
        return this.detailsDescription.content
          .slice(0)
          .splice(0, this.detailsDescription.contentLimiter);
      }
      return this.detailsDescription.content;
    },
    detailsListId () {
      return snakeCase(this.detailsDescription.header);
    },
  },
  methods: {
    snakeCase,
    isLastElemInArray (index, array) {
      return index === array.length - 1;
    },
  },
};
</script>
